import * as React from 'react';
import {Button} from '@mc/react-core';
import classNames from 'classnames';

const ClassNameNS = 'app-button-red';
const ClassName = ` ${ClassNameNS} bp3-intent-custom`;

import './RedButton.scss';

type Props = Omit<React.ComponentProps<typeof Button>, 'active' | 'fill' | 'intent' | 'outlined'>;

export class RedButton extends React.PureComponent<Props> {
    render() {
        const {className, ...other} = this.props;

        return <Button className={classNames(className, ClassName)} {...other} />;
    }
}
